import * as React from 'react';

import type { DegreesV1 } from 'bundles/degree-home/components/__generated__/DegreesV1';

type DegreeMetadataContextType = {
  degreeMetadata: DegreesV1 | null;
};

const DegreeMetadataContext = React.createContext<DegreeMetadataContextType>({ degreeMetadata: null });

export const useDegreeMetadataContext = () => {
  const context = React.useContext(DegreeMetadataContext);
  if (context === undefined) {
    throw new Error('useDegreeMetadataContext must be used within a DegreeMetadataContext');
  }
  return context;
};

type Props = {
  degreeMetadata: DegreesV1;
};

const DegreeMetadataContextProvider: React.LegacyFunctionComponentWithChildren<Props> = ({
  degreeMetadata,
  children,
}) => {
  return <DegreeMetadataContext.Provider value={{ degreeMetadata }}>{children}</DegreeMetadataContext.Provider>;
};

export default DegreeMetadataContextProvider;
